module.exports = __webpack_public_path__ + "svg/new-dankort-big.26b93b89f6c053495367c173589fc1e3.svg";